export default "__VITE_ASSET__42edaa38__"